import React from 'react';
import i18n from "i18next";
import { Card, Col, Row, Typography, Tooltip } from 'antd';
import { ApartmentOutlined, BookOutlined, UnorderedListOutlined, DatabaseOutlined, 
  MergeCellsOutlined } from '@ant-design/icons';

const { Title } = Typography;

const landingItems = () => [
  {
    title: i18n.t('views.admin.landing.schemes'), //'Cправочники'
    route: '/schemes',
    icon: <BookOutlined />,
  },
  {
    title: i18n.t('views.admin.landing.vocabs'), //'Реестры объектов'
    route: '/vocabs',
    icon: <UnorderedListOutlined />,
  },
  {
    title: i18n.t('views.admin.landing.catalogs'), //'Каталоги'
    route: '/catalogs',
    icon: <DatabaseOutlined />
  },
  {
    title: i18n.t('views.admin.landing.namespaces'), //'Пространство имён'
    route: '/namespaces',
    icon: <MergeCellsOutlined />
  },
  {
    title: i18n.t('views.admin.landing.sksaowl'), //'Онтология каталога'
    route: '/sksaowl',
    icon: <ApartmentOutlined />,
  },
];

/** Компонента для отображения плитки выбора маршрута в AdminPanel. */
class AdminInterfaceLanding extends React.Component {
  openRoute(route) {
    const { router } = this.props;
    if (router) router.navigate(route);
  }

  render() {
    const {isSignedIn, inGroup} = this.props;
    //alignItems: 'center',
    return (
      <div style={{minHeight: '70vh', display: 'flex',  justifyContent: 'center', padding: 24}}>
        <div style={{width: '100%', maxWidth: 1100}}>
          <Title level={3} style={{textAlign: 'center', marginBottom: 32, display: 'none'}}>{i18n.t('views.admin.landing.title')}</Title>
          <Row gutter={[24, 24]} justify="center">
          {landingItems().map(item => {
            const isDisabled = (["/sksaowl", "/catalogs", "/namespaces"].includes(item.route) && (!inGroup.Expert || inGroup.Demo || !isSignedIn));
            return (
              <Col key={item.route} xs={24} sm={12} lg={8}>
                <Tooltip title={isDisabled ? "Доступно только экспертам" : ""}>
                  <Card
                    hoverable={!isDisabled}
                    role={isDisabled ? undefined : "button"}
                    tabIndex={isDisabled ? -1 : 0}
                    onClick={() => {
                      if (!isDisabled) {
                        this.openRoute(item.route);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (isDisabled) return;

                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.openRoute(item.route);
                      }
                    }}
                    bodyStyle={{
                      minHeight: 180,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      opacity: isDisabled ? 0.45 : 1,
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      userSelect: 'none',
                    }}
                  >
                    <div style={{ fontSize: 40, lineHeight: 1, marginBottom: 20 }}>
                      {item.icon}
                    </div>

                    <Title level={4} style={{ margin: 0 }}>
                      {item.title}
                    </Title>
                  </Card>
                </Tooltip>
              </Col>
            );
          })}
          </Row>
        </div>
      </div>
    );
  }
}

export default AdminInterfaceLanding;
